import React from 'react';
import { createRoot } from 'react-dom/client';
import DevexHighOrderComponent from '../../src/components/react/devex_high_order_component/devex_high_order_component';
import PasswordReset from '../../src/password_reset/password_reset';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('reset-password-form-react-app');
  if (!container) return null;
  const root = createRoot(container);

  root.render(
    <DevexHighOrderComponent>
      <PasswordReset />
    </DevexHighOrderComponent>
  );
});
